module.exports = __webpack_public_path__ + "static/media/info.2f6cc22c.png";